<ps-footer-social class="social-media-icons">
  <a href="{{ 'FOOTER.FACEBOOK_LINK' | translate }}" target="_blank">
    <ps-icon size="small">facebook</ps-icon>
  </a>
  <a *ngIf="brand !== constants.NETELLER.brandName" href="{{ 'FOOTER.LINKEDIN_LINK' | translate }}" target="_blank">
    <ps-icon size="small">linkedin</ps-icon>
  </a>
  <a href="{{ 'FOOTER.TWITTER_LINK' | translate }}" target="_blank">
    <ps-icon size="small">twitter</ps-icon>
  </a>
</ps-footer-social>
